/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ShippingAndBilling.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date	    : Sep 10, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 10, 2019
 * Description   : ASDS-1200
 * By            : H224423
 * On            : Oct 10, 2019
 * Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Added city in address and removed unneccessary comma's
 *
 ******************************************************************************/

import React from 'react';
import {connect} from 'react-redux';
import RouteConstants from '../constants/route-constants';
import {
    Grid,
} from '@scuf/common';
import {Redirect} from 'react-router-dom';
import {
    IShippingAndBillingAddressProps,
    IAddressDetailsProps,
    IBillingAddressProps,
    IShippingAddressProps
} from '../utils/checkout-interfaces';


/**
 * Displays Shipping and Billing address block.
 * @param props
 */
function ShippingAndBillingAddress(props: IShippingAndBillingAddressProps) {
    if (props.soldTo && props.shipTo) {
        return (
            <Grid.Row>
                <BillingAddress addressDetails={props.soldTo}/>
                <ShippingAddress addressDetails={props.shipTo}/>
            </Grid.Row>
        );
    }
    return (<Redirect to={RouteConstants.SELECT_ACCOUNT}/>);
}

/**
 * Displays Shipping address block.
 * @param props
 */
function ShippingAddress(props: IShippingAddressProps) {
    return (
        <Grid.Column width={6} swidth={12}>
            <Grid.Row>
                <Grid.Column className="address-header-text padd-bottom-10" width={12}>Shipping Destination</Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={12} className="address-header-text ">
                    <AddressDetailsComponent addressDetails={props.addressDetails}/>
                </Grid.Column>
            </Grid.Row>
        </Grid.Column>
    );
}

/**
 * Displays Billing address block.
 * @param props
 */
function BillingAddress(props: IBillingAddressProps) {
    return (
        <Grid.Column width={6} swidth={12}>
            <Grid.Row>
                <Grid.Column className="address-header-text padd-bottom-10" width={12}>Billing Account</Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={12} className="address-header-text">
                    <AddressDetailsComponent addressDetails={props.addressDetails}/>
                </Grid.Column>
            </Grid.Row>
        </Grid.Column>
    );
}

/**
 * Common component for Shipping and Billing address details.
 * @param props
 */
function AddressDetailsComponent(props: IAddressDetailsProps) {
    const {
        customerName, addrLine1 = '', addrLine2 = '', addrLine3 = '', country = '', state = '', zip = '',city='',
        sapNumber: accountId = ''
    } = props.addressDetails;
    return (
        <div className="shipping_address"> {/* this div block is for JIRA ASDS-685*/}
            <div>
                <b>{customerName}</b>
            </div>
            <div className="link-like-text">HONEYWELL CUSTOMER CODE: {accountId}</div>
            <div className="addressBody">
            {`${addrLine1 ? addrLine1 + ', ' : ''}${addrLine2 ? addrLine2 + ', ' : ''}${addrLine3 ? addrLine3 + ', ' : ''}${city ? city + ', ' : ''}${state ? state + ', ' : ''}${country ? country + ', ' : ''}${zip ?  zip : ''}`}
            </div>
        </div>
    );
}

export function mapSelectAccountToProps(state): IShippingAndBillingAddressProps {
    const {isFetching, payload} = state.selectAccount.selectAccountDetails;
    // contains soldTo and shipTo only then return object else return undefined.
    if (!isFetching && payload.shipTo && payload.soldTo && payload.shipTo.accountId && payload.soldTo.accountId) {
        return {
            soldTo: payload.soldTo,
            shipTo: payload.shipTo,
        }
    }
    return {
        soldTo: undefined,
        shipTo: undefined,
    };
}

export default connect(mapSelectAccountToProps)(ShippingAndBillingAddress);